import * as React from "react";

import {ArticleEmbedMetadata} from "../types/ArticleEmbedMetadata";

interface Props {
    embedsMetadata: ArticleEmbedMetadata[];
}

export const SchemaArticleVideoDetail = ({embedsMetadata}: Props) => {
    if (!embedsMetadata.length) {
        return null;
    }

    const json = embedsMetadata.map((embed) => ({
        "@context": "https://schema.org",
        "@type": "VideoObject",
        "@id": embed.contentUrl,
        name: embed.name,
        description: embed.description,
        thumbnailUrl: embed.thumbnailUrl,
        uploadDate: embed.uploadDate,
        duration: embed.duration,
        embedUrl: embed.embedUrl,
        contentUrl: embed.contentUrl
    }));

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
import * as React from "react";

import {ArticleEmbedMetadata} from "../types/ArticleEmbedMetadata";

interface Props {
    embedsMetadata: ArticleEmbedMetadata[];
}

export const SchemaArticleVideoDetail = ({embedsMetadata}: Props) => {
    if (!embedsMetadata.length) {
        return null;
    }

    const json = embedsMetadata.map((embed) => ({
        "@context": "https://schema.org",
        "@type": "VideoObject",
        "@id": embed.contentUrl,
        name: embed.name,
        description: embed.description,
        thumbnailUrl: embed.thumbnailUrl,
        uploadDate: embed.uploadDate,
        duration: embed.duration,
        embedUrl: embed.embedUrl,
        contentUrl: embed.contentUrl
    }));

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
